import type { CartNextDeliveryTime } from "@server/gql/graphql";

export const getNextDeliveryDate = (
  nextDelivery?: CartNextDeliveryTime | null,
) => {
  if (
    !nextDelivery?.date ||
    nextDelivery?.quantity === undefined ||
    nextDelivery.quantity === 0
  )
    return undefined;

  const date = new Date(nextDelivery.date);
  const time = date.getTime();

  // Guard against unparseable dates and the .NET DateTime.MinValue sentinel
  // ("0001-01-01T00:00:00+00:00") the backend sends instead of null. A real
  // delivery date is always after the Unix epoch.
  if (Number.isNaN(time) || time <= 0) {
    return undefined;
  }

  return date;
};
